
import angular from "angular";

import SubscriptionService from "./SubscriptionService";
import StateCommonSubscriptionService from "./StateCommonSubscriptionService";

import StateDataServiceModule from "../StateDataService";

const mStateDataSvc = new WeakMap();
const mStateCommonSubscriptionSvc = new WeakMap();

class StateOfficeSubscriptionService extends SubscriptionService {
    constructor($q, StateData) {
        super();

        mStateCommonSubscriptionSvc.set(this, new StateCommonSubscriptionService($q, StateData));
        mStateDataSvc.set(this, StateData);
    }

    getTarget(stateTargetId) {
        return mStateCommonSubscriptionSvc.get(this).getTarget(stateTargetId);
    }

    getTargetBatch(stateTargetIds) {
        return mStateCommonSubscriptionSvc.get(this).getTargetBatch(stateTargetIds);
    }

    addSubscription(recipientId, stateTargetId) {
        let subAddPromise =
            mStateCommonSubscriptionSvc.get(this)
                .addSubscription(
                    recipientId,
                    stateTargetId,
                    (params) => mStateDataSvc.get(this).addElectionSubscription(params),
                    (stModel) => stModel.stateOfficeSubscribers
                );

        return subAddPromise;
    }

    removeSubscription(recipientId, stateTargetId) {
        let subDelPromise =
            mStateCommonSubscriptionSvc.get(this)
                .removeSubscription(
                    recipientId,
                    stateTargetId,
                    (params) => mStateDataSvc.get(this).removeElectionSubscription(params),
                    (stModel) => stModel.stateOfficeSubscribers
                );

        return subDelPromise;
    }

}

StateOfficeSubscriptionService.$inject = [ "$q", "StateData" ];

export default angular
    .module("trackerbase-app.services.subscription-data-adapters.state-office-subscription-service",[
        StateDataServiceModule
    ])
    .service("StateOfficeSubscriptionData", StateOfficeSubscriptionService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/subscription-data-services/StateOfficeSubscriptionService.js
// module id = wgwF
// module chunks = 1